import { render } from "./Logo.vue?vue&type=template&id=3face5ce&scoped=true"
const script = {}

import "./Logo.vue?vue&type=style&index=0&id=3face5ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3face5ce"]])

export default __exports__